// extracted by mini-css-extract-plugin
export default {"title":"_5e7d802a52","bld":"_41736c8d6f"};